import { apiGet, apiPut } from "../client";
import type {
  UpdateUserPreferenceDefaultsRequest,
  UserPreferenceDefaultsApi,
} from "../models/userPreferenceDefaults";

export async function getUserPreferenceDefaults(): Promise<UserPreferenceDefaultsApi> {
  return apiGet<UserPreferenceDefaultsApi>("system/user-defaults");
}

export async function updateUserPreferenceDefaults(
  request: UpdateUserPreferenceDefaultsRequest,
): Promise<UserPreferenceDefaultsApi> {
  return apiPut<UserPreferenceDefaultsApi>("system/user-defaults", request);
}
